import { useAsset } from "provider/AssetProvider";
import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

type Props = {
    path: string,
    label: string,
    icon: string,
    stakingAddress?: string,
    svg?: ReactNode
}

export function SidebarMenuItem({ path, label, icon, stakingAddress, svg }: Props) {
    const { pathname } = useLocation()

    return <li className={`menu-item ${pathname == path ? "active" : ""}`}>
        <Link to={stakingAddress ? `/${stakingAddress}${path}` : path} className="menu-link">
            {
                svg && svg
            }
            {
                !svg && <i className={`menu-icon tf-icons bx bx-${icon}`}></i>
            }

            <div>{label}</div>
        </Link>
    </li>
}